/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddReferenceableSyncEntityRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {AddReferenceableSyncEntityResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const addReferenceableSyncEntity = (request: AddReferenceableSyncEntityRequest, options?: CashRequestOptions) => post<AddReferenceableSyncEntityRequest, AddReferenceableSyncEntityResponse>("/2.0/cash/add-referenceable-sync-entity", request, {...options, rejectOnError: true })